interface LayersIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export function LayersIcon({ color = 'currentColor', ...svgProps }: LayersIconProps) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M0.231525 9.31732C0.380866 9.12724 0.640709 9.07437 0.848713 9.17864L0.933674 9.23235L8.19149 14.9345L8.26278 14.9814C8.43545 15.0746 8.65015 15.059 8.80867 14.9345L16.0665 9.23235C16.2836 9.0621 16.5981 9.10031 16.7686 9.31732C16.9388 9.53443 16.9006 9.84899 16.6837 10.0195L9.42684 15.7216C8.9169 16.1221 8.212 16.1464 7.67781 15.7958L7.57332 15.7216L0.316486 10.0195L0.243244 9.94915C0.0928634 9.77189 0.0826163 9.50734 0.231525 9.31732ZM7.87996 1.12493C8.1995 0.869472 8.63656 0.837592 8.98543 1.02923L9.12996 1.12493L15.962 6.59368C16.4619 6.99383 16.4624 7.75474 15.963 8.15521L9.12996 13.6249L8.98543 13.7206C8.63656 13.9122 8.19948 13.8804 7.87996 13.6249L1.03914 8.15618L0.951252 8.07708C0.56796 7.68975 0.567892 7.06007 0.951252 6.67278L1.03914 6.59368L7.87996 1.12493ZM1.66414 7.37493L8.50496 12.8437L15.337 7.37493L8.50399 1.90521L1.66414 7.37493Z"
        fill={color}
      />
    </svg>
  );
}
